try{
	const ipcRenderer = window.require('electron').ipcRenderer;

	window.addEventListener('keydown',e=>{
		if(e.keyCode===27) ipcRenderer.send('quit');
	});
} catch(e){}

export default {};